// src/pages/CreateTalleresNoAutorizadosForm.jsx
import React, { useState } from "react";
import { Form, Input, Button, InputNumber, message } from "antd";
import { createTalleresNoAutorizados } from "../api/talleresNoAutorizadosApi";

const CreateTalleresNoAutorizadosForm = ({ onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await createTalleresNoAutorizados(values);
      message.success("Taller creado exitosamente");
      onSuccess(); // Notificar éxito (para refrescar la lista y cerrar el modal)
    } catch (error) {
      console.error("Error al crear el taller:", error);
      message.error("Error al crear el taller");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600 }}>
      <h3>Crear Taller No Autorizado</h3>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Código"
          name="codigo"
          rules={[{ required: true, message: "Ingresa el código" }]}
        >
          <Input placeholder="Ej: TLA-001" />
        </Form.Item>
        <Form.Item
          label="Nombre"
          name="nombre"
          rules={[{ required: true, message: "Ingresa el nombre" }]}
        >
          <Input placeholder="Ej: Taller Ejemplo" />
        </Form.Item>
        <Form.Item
          label="Tipo Taller"
          name="tipoTaller"
          rules={[{ required: true, message: "Ingresa el tipo de taller" }]}
        >
          <Input placeholder="Ej: Mecánico" />
        </Form.Item>
        <Form.Item
          label="Dirección"
          name="direccion"
          rules={[{ required: true, message: "Ingresa la dirección" }]}
        >
          <Input placeholder="Ej: Calle 123" />
        </Form.Item>
        <Form.Item
          label="Ciudad"
          name="ciudad"
          rules={[{ required: true, message: "Ingresa la ciudad" }]}
        >
          <Input placeholder="Ej: Loja" />
        </Form.Item>
        <Form.Item
          label="Agencia Cercana"
          name="agenciaCercana"
          rules={[{ required: true, message: "Ingresa la agencia cercana" }]}
        >
          <Input placeholder="Ej: Agencia XYZ" />
        </Form.Item>
        <Form.Item
          label="Marca"
          name="marca"
          rules={[{ required: true, message: "Ingresa la marca" }]}
        >
          <Input placeholder="Ej: NISSAN" />
        </Form.Item>
        <Form.Item
          label="Latitud"
          name="latitud"
          rules={[{ required: true, message: "Ingresa la latitud" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="-3.98634" />
        </Form.Item>
        <Form.Item
          label="Longitud"
          name="longitud"
          rules={[{ required: true, message: "Ingresa la longitud" }]}
        >
          <InputNumber style={{ width: "100%" }} placeholder="-79.2054" />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ marginRight: 8 }}
          >
            Crear Taller
          </Button>
          <Button onClick={onCancel}>Cancelar</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateTalleresNoAutorizadosForm;
